import { DomainsPermissions } from '../../constants';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const domainsPermissions = async _ref => {
  let {
    httpClient,
    request: {
      msid
    }
  } = _ref;
  const {
    domainsAccount
  } = await dynamicLoadApiQueries(httpClient);
  const {
    domainPermissions
  } = await domainsAccount({});
  const hasBillingPermissions = !!(domainPermissions != null && domainPermissions.includes(DomainsPermissions.AccountLevelPurchaseDomain)) || !!msid && !!(domainPermissions != null && domainPermissions.includes(DomainsPermissions.SiteLevelPurchaseDomain));
  const hasManageDomainPermissions = hasBillingPermissions || !!(domainPermissions != null && domainPermissions.includes(DomainsPermissions.AccountLevelManageDomains)) || !!msid && !!(domainPermissions != null && domainPermissions.includes(DomainsPermissions.SiteLevelManageDomains));
  return {
    hasManageDomainPermissions,
    hasBillingPermissions
  };
};
//# sourceMappingURL=domainsPermissions.js.map